import React from 'react';
import PropTypes from 'prop-types';

const ItemSelectorDetails = ({
  brand,
  productName,
  color,
}) => (
  <div className="details">
    <div className="product">
      <span className="label">PRODUCT:</span>{' '}
      <span className="value">
        {brand} {productName}
      </span>
    </div>
    <div className="color">
      <span className="label">COLOR:</span>{' '}
      <span className="value">{color}</span>
    </div>
  </div>
);
ItemSelectorDetails.propTypes = {
  brand: PropTypes.string.isRequired,
  productName: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
};
export default ItemSelectorDetails;
